export const FILTER_FIELDS_SERVICE = {
  exam: "medical_procedure_id",
  consultation: "client_speciality_id",
};
